import { MemberManager } from '../../managers/member.manager';
import { Title } from '@angular/platform-browser';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { AddNotePromptDialog } from '../add.note.prompt/add.note.prompt.dialog';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

export interface IMemberDetailsDialogModel {
  memberManager: MemberManager;
}

@Component({
  selector: 'member-details-dialog',
  styleUrls: ['./member.details.dialog.css'],
  templateUrl: './member.details.dialog.html'
})
export class MemberDetailsDialog extends DialogComponent<IMemberDetailsDialogModel, boolean> implements IMemberDetailsDialogModel, OnInit, OnDestroy {

  memberManager: MemberManager;


  private originalTitle: string;

  constructor(dialogService: DialogService, private titleService: Title, private sweetAlert: SweetAlertService, public gb: GlobalService, public router: Router) {
    super(dialogService, router);
  }

  ngOnInit() {
    this.originalTitle = this.titleService.getTitle();
    this.titleService.setTitle('Edit ' + this.memberManager.newEntity.FirstName + ' ' + this.memberManager.newEntity.LastName);
  }

  ngOnDestroy() {
    this.titleService.setTitle(this.originalTitle);
  }

  confirm() {

    let disposable = this.dialogService.addDialog( AddNotePromptDialog, {
      title : 'Edit Member Note',
      showCancel : true
    }, {
      width: 400,
      height: 500,
      IsRequired: true
    }).subscribe(result => {
      disposable.unsubscribe();

      if ( result == 'cancel' ) {
        return;
      } else {
        // update note parameter here:
        let newNote = result;

        this.memberManager.SaveChanges(true, true, newNote);

        let saved = this.memberManager.OnChangesSaveResponse.subscribe(response => {
          saved.unsubscribe();

          if (response.Result) {
            this.sweetAlert.swal({
              type: 'success',
              title: 'Member Saved',
              text: 'Member has been saved successfully',
              timer: 1500
            }).then( () => { this.closeOK(); }, () => { this.closeOK(); } )
          } else {
            this.sweetAlert.swal({
              type: 'error',
              title: 'Save Failed',
              text: response.ResultMessage
            })
          }

        });
      }

    });

  }

  closeOK() {
    // we set dialog result as true on click on confirm button,
    // then we can get dialog result from caller code
    this.result = true;
    this.close();

  }

}
